import reqest from "../common/reqest";

/**
 * 直播间论坛列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getBroadcastList(data) {
  return reqest.send("/Pub/Broadcast_SelectList", data)
}

/**
 * 获取直播间进入链接
 * @param data
 * @returns {Promise<unknown>}
 */
export function getLiveUrl(data) {
  return reqest.send("/Live/Live_Url",data)
}


/**
 * 直播间角色验证
 * @param data
 * @returns {Promise<unknown>}
 */
export function checkUser(data) {
  return reqest.send("/Live/Check_User", data)
}

/**
 * 查看联系方式
 * @param data
 * @returns {Promise<unknown>}
 */
export function selectContact(data) {
  return reqest.send("/BroadcastBbs/See_Contact", data)
}


/**
 * 直播间参展用户列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getLiveUser(data) {
  return reqest.send("/LiveOperation/Live_User_List", data)
}


/**
 * 直播间参展用户进入和离开时间列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getLiveTime(data) {
  return reqest.send("/LiveOperation/Live_User_Time_List", data)
}

/**
 * 直播间回放列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function callbackPlay(data) {
  return reqest.send("/LiveOperation/Callback_Play", data)
}

/**
 * 获取直播间回放视频地址
 * @param data
 * @returns {Promise<unknown>}
 */
export function callbackPlatVodio(data) {
  return reqest.send("/LiveOperation/Callback_Play_vodio", data)
}

/**
 * 上传图片
 * @param data
 * @returns {Promise<unknown>}
 */
export function uploadImage(data) {
  return reqest.send("/Publicother/uploadpic", data)
}
